import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IPromoModalInformationResponse } from "@faire/web-api--source/indigofair/data/IPromoModalInformationResponse";

export const getPromoModalInformation = (): IPromoModalInformationResponse =>
  getGlobalProperty("promoModalInformation") ??
  IPromoModalInformationResponse.build({
    type: "NONE",
  });
